var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83366 14.7155V16.6667C8.83366 17.5871 9.57985 18.3333 10.5003 18.3333C11.4208 18.3333 12.167 17.5871 12.167 16.6667V14.7155M10.5003 1.66667V2.50001M3.00033 10H2.16699M5.08366 4.58334L4.58358 4.08326M15.917 4.58334L16.4172 4.08326M18.8337 10H18.0003M15.5003 10C15.5003 12.7614 13.2618 15 10.5003 15C7.7389 15 5.50033 12.7614 5.50033 10C5.50033 7.23858 7.7389 5.00001 10.5003 5.00001C13.2618 5.00001 15.5003 7.23858 15.5003 10Z",
    stroke: "#007EF5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light_bulb.1f34ebc84a85ac5144e68a92a67aa284.svg";
export { ForwardRef as ReactComponent };